import { Button, Icon } from "@legal-500/legal500-design-system";
import type { Package } from "../../../api/packages.service";
import styles from "../PackageVersionModal.module.css";

export type Step1ImpactWarningProps = {
  package: Package;
  onContinue: () => void;
  onCancel: () => void;
};

export function Step1ImpactWarning({
  package: pkg,
  onContinue,
  onCancel,
}: Step1ImpactWarningProps) {
  const nextVersion = pkg.version + 1;

  return (
    <>
      <div className={styles.modalHeader}>
        <div className={styles.headerContent}>
          <div className={styles.iconWrapper} aria-hidden="true">
            <Icon icon="copy" size="large" />
          </div>
          <h2 id="version-package-title" className={styles.modalTitle}>
            Create Version {nextVersion}?
          </h2>
        </div>
        <button
          className={styles.modalCloseButton}
          onClick={onCancel}
          aria-label="Close modal"
          type="button"
        >
          <Icon icon="cross" size="small" />
        </button>
      </div>

      <div className={styles.modalBody}>
        <p className={styles.versionMessage}>This will create a new version of:</p>
        <p className={styles.packageName}>
          <strong>
            {pkg.name} ({pkg.productCode})
          </strong>{" "}
          v{pkg.version}
        </p>

        <div className={styles.impactWarningBox}>
          <div className={styles.warningIcon} aria-hidden="true">
            <Icon icon="exclamation" size="small" />
          </div>
          <div className={styles.impactContent}>
            <h3 className={styles.impactTitle}>What Happens to Subscriptions:</h3>

            <div className={styles.impactSection}>
              <p className={styles.impactLabel}>Existing Subscriptions:</p>
              <p className={styles.impactText}>
                Will continue working with version {pkg.version} features unchanged. They are{" "}
                <strong>NOT affected</strong>.
              </p>
            </div>

            <div className={styles.impactSection}>
              <p className={styles.impactLabel}>Version {pkg.version}:</p>
              <p className={styles.impactText}>
                Will be deactivated - future subscriptions cannot use it.
              </p>
            </div>

            <div className={styles.impactSection}>
              <p className={styles.impactLabel}>Version {nextVersion}:</p>
              <p className={styles.impactText}>
                Will become the active version - all future subscriptions will use it.
              </p>
            </div>
          </div>
        </div>

        <p className={styles.nextStepInfo}>Next: Select features for version {nextVersion}</p>
      </div>

      <div className={styles.modalFooter}>
        <Button variant="outlined" color="default" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onContinue}
          className={styles.primaryButton}
        >
          Continue
        </Button>
      </div>
    </>
  );
}
